import React, { useState } from "react";
import { pageTitle } from "../PageTitle";
import HeaderOne from "../Header/HeaderOne";
import FooterOne from "../Footer/FooterOne";
import { Link, useLocation } from "react-router-dom";
import g1 from "../../assets/images/resource/wa-agents.png";
import { Helmet } from "react-helmet-async";
import service1 from "./../../assets/images/banner/ab.png";
import service2 from "./../../assets/images/banner/customer-support.png";
import service3 from "./../../assets/images/banner/food-ord.png";
import service4 from "./../../assets/images/banner/ia.png";
import service6 from "./../../assets/images/banner/dashboard.png";
import service5 from "./../../assets/images/banner/attendance.png";
import {
  FaUtensils,
  FaHardHat,
  FaIndustry,
  FaShoppingCart,
  FaGraduationCap,
  FaSpa,  
} from "react-icons/fa";

const Whatsapp = () => {
  pageTitle("AI WhatsApp Agents");

  const handleWhatsAppClick = () => {
    const phoneNumber = "6590059743"; // WhatsApp number (no '+' or spaces)
    const message = "Hello! I would like to know more about your services.";
    const url = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
    window.open(url, "_blank");
  };

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    subject: "",
    phone: "",
    message: "",
  });
  const location = useLocation();
  const pathnames = location.pathname.split("/").filter((x) => x);
  const handleSubmit = (e) => {
    e.preventDefault();

    // Your logic to handle form submission goes here
    console.log("Form submitted:", formData);

    // Clear the form fields after submission if needed
    setFormData({
      name: "",
      email: "",
      subject: "",
      phone: "",
      message: "",
    });
  };

 const servicesData = [
   { id: 1, title: "AI WhatsApp Agents", slug: "/Whatsapp-estore" },
   { id: 2, title: "RPA", slug: "/RPA-AI" },
   { id: 3, title: "Data & Analytics", slug: "/Data-Analytics" },
   // { id: 4, title: "Web Development", slug: "/Web-Development" },
   // { id: 5, title: "Digital Consulting", slug: "/digital-consultancy" },
   // { id: 6, title: "Data Science", slug: "/Data-Science" },
 ];

  const renderServices = () => {
    return servicesData.map((service) => (
      <li
        key={service.id}
        className={service.slug === "/Whatsapp-estore" ? "active" : ""}
      >
        <Link to={service.slug}>{service.title}</Link>
      </li>
    ));
  };

  return (
    <>
      <Helmet>
        <title>WhatsApp Estore Services | Transform Your Business</title>
        <meta
          name="description"
          content="Transform your business by leveraging WhatsApp for your E-store, enhancing customer engagement, and driving sales."
        />
        <meta
          name="keywords"
          content="WhatsApp, E-store, Customer Support, Sales, Product Catalog"
        />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href="https://siw.sg/Whatsapp-estore" />
      </Helmet>

      <HeaderOne></HeaderOne>
      {/* <BreadCrumb></BreadCrumb> */}
      <section className="page__title p_relative">
        <div
          className="bg-layer"
          style={{
            backgroundImage: `url(${g1})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
          }}
        ></div>
      </section>

      {/* Image */}
      {/* <div className="col-xl-8 col-lg-8 col-md-12 service__right whatsapp-image-section">
              <figure>
                <img src={service} alt="" className="service-images" />
              </figure>
            </div> */}

      {/* Video - desktop/tablet right side, mobile last */}
      {/* <div className="col-xl-4 col-lg-4 col-md-12 service__details__left whatsapp-video-section">
              <div
                className="sidebar__widget_network"
                style={{ backgroundImage: `url(${basebg})` }}
              >
                <h3 style={{ paddingBottom: "20px" }}>WhatsApp Services</h3>
                <video controls style={{ width: "100%", marginRight: "10px" }}>
                  <source src={videoSource} type="video/mp4" />
                  Your browser does not support the video tag.
                </video>
              </div>
            </div> */}

      {/* Full Width Overview */}
      {/* <div className="col-12 service__full__content whatsapp-overview-section">
              <h2>WhatsApp Services Overview</h2>

              <ul>
                <li>
                  <strong>Automation:</strong> Enables chatbots and
                  pre-configured workflows to handle customer queries
                  efficiently.
                </li>
                <li>
                  <strong>Template Messaging:</strong> Allows sending structured
                  and compliant messages for promotions or transactions.
                </li>
                <li>
                  <strong>CRM Integration:</strong> Seamlessly connects with
                  tools like Shopify, HubSpot, and Zoho for better lead and
                  customer management.
                </li>
                <li>
                  <strong>Analytics:</strong> Provides insights into campaign
                  performance, operator efficiency, and customer interactions.
                </li>
                <li>
                  <strong>e-Commerce Support:</strong> Features like product
                  catalogs, auto-checkout, and payment integration cater to
                  online sales.
                </li>
                <li>
                  <strong>Mobile Accessibility:</strong> A dedicated app ensures
                  businesses can manage operations on the go.
                </li>
              </ul>
            </div> */}

      {/* Full Width Main Content */}
      {/* <div className="col-12 wd whatsapp-main-content-section">
              <h4 style={{ paddingTop: "10px" }}>WhatsApp Store</h4>
              <p>
                The WhatsApp Store allows businesses to showcase their products
                in a catalog, enabling customers to browse and order directly
                through WhatsApp. This feature integrates seamlessly into the
                chat interface, offering an intuitive shopping experience
                without requiring external links or apps.
              </p>

              <h4>Payment Automation Flow</h4>
              <ul>
                <li>
                  <strong>Order Placement:</strong> Customers can browse a
                  catalog embedded in the chat and select items they wish to
                  purchase. Each selection adds items to a virtual cart.
                </li>
                <li>
                  <strong>Checkout Process:</strong> Customers confirm their
                  order directly in the chat interface. Payment details and
                  options, such as card payments or integration with third-party
                  platforms, are presented.
                </li>
                <li>
                  <strong>Payment Integration:</strong> Payment gateways handle
                  secure transactions, offering real-time payment updates.
                  Automated confirmation messages are sent to both customers and
                  businesses upon successful payment.
                </li>
                <li>
                  <strong>Order Tracking:</strong> Post-payment, the system
                  shares delivery details, including order status and estimated
                  delivery time, enhancing customer communication.
                </li>
              </ul>

              <h4 style={{ paddingTop: "10px" }}>WhatsApp e-Commerce</h4>
              <p>
                Integrating WooCommerce with WhatsApp enhances the e-commerce
                experience by automating customer interactions. This integration
                enables businesses to send automated order confirmations,
                payment updates, and delivery notifications directly through
                WhatsApp. Additionally, it supports two-way communication,
                allowing customers to send queries or seek support seamlessly.
              </p>

              <ul>
                <li>
                  <strong>Automated Order Replies:</strong> Automatically
                  respond to customers with order details such as order ID,
                  payment status, and estimated delivery time after they place
                  an order.
                </li>
                <li>
                  <strong>Customer Queries Management:</strong> Enable real-time
                  handling of customer inquiries related to products, orders, or
                  delivery through predefined message templates or dynamic
                  responses triggered by keywords.
                </li>
                <li>
                  <strong>Customization with Variables:</strong> Use predefined
                  variables to dynamically include customer-specific data in
                  automated messages, such as names, order IDs, or product
                  details.
                </li>
                <li>
                  <strong>Streamlined Communication Flow:</strong> Set up
                  workflows for abandoned cart reminders, order confirmations,
                  or payment follow-ups to boost sales and enhance customer
                  experience.
                </li>
                <li>
                  <strong>Enhanced Shopping Experience:</strong> Customers can
                  directly engage via WhatsApp for product inquiries, and
                  businesses can leverage the chatbot for catalog browsing and
                  checkout guidance.
                </li>
              </ul>

              <h4 style={{ paddingTop: "10px" }}>WhatsApp API Integration</h4>
              <ul>
                <li>
                  <strong>Real-Time Data Sharing:</strong> Webhooks enable
                  instant communication between systems by pushing data updates
                  in real time.
                </li>
                <li>
                  <strong>Efficient Workflow Automation:</strong> Actions like
                  order confirmations, status updates, and customer query
                  resolutions are triggered automatically through webhook
                  notifications.
                </li>
                <li>
                  <strong>Tracking Template Messages:</strong> Webhooks monitor
                  the lifecycle of template messages, helping businesses track
                  delivery statuses, ensure compliance, and optimize engagement.
                </li>
                <li>
                  <strong>Personalized Updates:</strong> By integrating OpenAI,
                  webhook data can be analyzed to create personalized customer
                  notifications, further enhancing user interaction.
                </li>
              </ul>

              <p style={{ margin: "5px 0 20px" }}>
                Ready to revolutionize your business? Contact us today and let
                us help you create a WhatsApp service that drives sales and
                keeps customers coming back!
              </p>
            </div> */}

      <section class="siw-rpa-section">
        <div class="siw-rpa-container-data-engineering container">
          <div class="siw-rpa-content">
            <span class="siw-rpa-tag text-left">
              WhatsApp API that is trusted for messaging at scale
            </span>

            <div class="siw-rpa-text">
              <p>
                Start conversations that drive conversions. When you connect to
                the WhatsApp business platform, you can engage with your
                customer on a channel they trust. For every interaction across
                the customer journey, WhatsApp empowers you to build a trusted
                relationship with your customers.
              </p>
            </div>
          </div>
        </div>
      </section>
      <section className="wa-zigzag-section">
        <div className="container">
          <div className="wa-zigzag-title">
            <h2>AI WhatsApp Agent Features</h2>
            <p>
              Build smarter customer journeys with automated WhatsApp
              conversations, ordering, appointment booking, invoice processing,
              attendance tracking, customer service, and analytics.
            </p>
          </div>

          {/* 1 - WhatsApp Ordering */}
          <div className="wa-zigzag-row">
            <div className="wa-zigzag-image">
              <img src={service3} alt="WhatsApp ordering" />
            </div>

            <div className="wa-zigzag-content">
              <h3>WhatsApp Ordering</h3>
              <p>
                Let customers browse menus, select items, confirm quantities,
                and place orders directly through WhatsApp.
              </p>
              <p>
                The system captures order details, shares instant summaries, and
                helps your team manage orders faster.
              </p>
              <button onClick={handleWhatsAppClick} className="siw-rpa-btn">
                TALK TO US
              </button>
            </div>
          </div>

          {/* 2 - Appointment Booking */}
          <div className="wa-zigzag-row reverse">
            <div className="wa-zigzag-image">
              <img src={service1} alt="WhatsApp appointment booking" />
            </div>

            <div className="wa-zigzag-content">
              <h3>WhatsApp Appointment Booking</h3>
              <p>
                Let customers book appointments by selecting the service,
                preferred date, and available time slot.
              </p>
              <p>
                The system captures customer details, confirms bookings
                instantly, and sends reminders automatically.
              </p>
              <button onClick={handleWhatsAppClick} className="siw-rpa-btn">
                TALK TO US
              </button>
            </div>
          </div>

          {/* 3 - Invoice Automation */}
          <div className="wa-zigzag-row">
            <div className="wa-zigzag-image">
              <img src={service4} alt="WhatsApp invoice automation" />
            </div>

            <div className="wa-zigzag-content">
              <h3>Invoice & Document Automation</h3>
              <p>
                Capture invoices, receipts, and documents from WhatsApp and
                extract key details automatically.
              </p>
              <p>
                Prepare structured records for finance, accounting, approval,
                and reporting workflows.
              </p>
              <button onClick={handleWhatsAppClick} className="siw-rpa-btn">
                TALK TO US
              </button>
            </div>
          </div>

          {/* 4 - Attendance Tracking */}
          <div className="wa-zigzag-row reverse">
            <div className="wa-zigzag-image">
              <img src={service5} alt="WhatsApp attendance tracking" />
            </div>

            <div className="wa-zigzag-content">
              <h3>Attendance & Field Updates</h3>
              <p>
                Collect attendance, site photos, task updates, and daily reports
                from field teams through WhatsApp.
              </p>
              <p>
                Track check-ins, late entries, image proof, and team activity in
                a structured dashboard.
              </p>
              <button onClick={handleWhatsAppClick} className="siw-rpa-btn">
                TALK TO US
              </button>
            </div>
          </div>

          {/* 5 - Customer Service */}
          <div className="wa-zigzag-row">
            <div className="wa-zigzag-image">
              <img src={service2} alt="WhatsApp customer service automation" />
            </div>

            <div className="wa-zigzag-content">
              <h3>Customer Service Automation</h3>
              <p>
                Answer customer questions instantly, manage FAQs, and route
                complex queries to your support team.
              </p>
              <p>
                Keep conversation history, improve response time, and deliver
                smoother customer support on WhatsApp.
              </p>
              <button onClick={handleWhatsAppClick} className="siw-rpa-btn">
                TALK TO US
              </button>
            </div>
          </div>

          {/* 6 - Analytics */}
          <div className="wa-zigzag-row reverse">
            <div className="wa-zigzag-image">
              <img src={service6} alt="WhatsApp analytics dashboard" />
            </div>

            <div className="wa-zigzag-content">
              <h3>Analytics & Dashboard</h3>
              <p>
                Track conversations, orders, bookings, support activity,
                attendance, and campaign performance in one place.
              </p>
              <p>
                View clean dashboards to understand customer activity and
                improve business decisions.
              </p>
              <button onClick={handleWhatsAppClick} className="siw-rpa-btn">
                TALK TO US
              </button>
            </div>
          </div>
        </div>
      </section>
      {/* Industries Section */}
      <div className="col-12 whatsapp-industries-section">
        <div className="whatsapp-industries-inner container py-5">
          <h2>AI WhatsApp across industries</h2>

          <p className="whatsapp-industries-subtitle">
            We've deployed WhatsApp agents across 6+ industries in Singapore.
            Each one is custom — trained on the specific products, services, and
            conversation patterns of that business.
          </p>

          <div className="whatsapp-industries-grid">
            <div className="whatsapp-industry-card">
              <a href="/wa-food-ordering">
                <div className="wafod-feature-icon">
                  <FaUtensils />
                </div>
                <h4>F&amp;B</h4>
                <p>
                  Automates menu enquiries, food orders, table bookings,
                  delivery updates, and customer follow-ups through WhatsApp.
                </p>
              </a>
            </div>

            <div className="whatsapp-industry-card">
              <a href="/wa-attendance">
                <div className="wafod-feature-icon">
                  <FaHardHat />
                </div>
                <h4>Construction</h4>
                <p>
                  Supports site attendance, worker updates, material requests,
                  project coordination, and daily reporting.
                </p>
              </a>
            </div>

            <div className="whatsapp-industry-card">
              <a href="/wa-chatbot">
                <div className="wafod-feature-icon">
                  <FaIndustry />
                </div>
                <h4>Manufacturing</h4>
                <p>
                  Handles quotation requests, order confirmations, production
                  updates, inventory checks, and delivery notifications.
                </p>
              </a>
            </div>

            <div className="whatsapp-industry-card">
              <a href="/wa-grocery-ordering">
                <div className="wafod-feature-icon">
                  <FaShoppingCart />
                </div>
                <h4>Retail &amp; E-commerce</h4>
                <p>
                  Manages product enquiries, catalogue browsing, order tracking,
                  returns, promotions, and customer support.
                </p>
              </a>
            </div>

            <div className="whatsapp-industry-card">
              <a href="/wa-invoice">
                <div className="wafod-feature-icon">
                  <FaGraduationCap />
                </div>
                <h4>Education &amp; Tuition</h4>
                <p>
                  Automates course enquiries, class schedules, fee reminders,
                  student updates, registration, and parent communication.
                </p>
              </a>
            </div>
            <div className="whatsapp-industry-card">
              <a href="#">
                <div className="wafod-feature-icon">
                  <FaSpa />
                </div>
                <h4>Spas &amp; Salons</h4>
                <p>
                  Automates appointment bookings, service enquiries, therapist
                  availability, package promotions, reminders, and customer
                  follow-ups.
                </p>
              </a>
            </div>
          </div>
        </div>
      </div>
      <FooterOne></FooterOne>
      <style>{`
       @media (min-width: 992px) {
        .service__details__left{
            height:50vh;
            }
       
            
        }
      `}</style>
    </>
  );
};

export default Whatsapp;
